import type { IExcelOptions } from '@/modules/Core/interfaces'
import { downloadFile } from '@/modules/Core/usings/generales'
import ExcelJS from 'exceljs'

export async function export_json_to_excel (
  {
    multiHeader = [],
    header,
    data,
    filename,
    merges = [],
    dataValidations = [],
    autoWidth = true,
    bookType = 'xlsx',
    sheets = ['Page1'],
    hiddens = [],
    download = true
  }: IExcelOptions = {} as IExcelOptions
) {
  const workbook = new ExcelJS.Workbook()
  filename = filename || 'excel-list'

  for (const sheetName of sheets) {
    let rowData = 2
    const worksheet = workbook.addWorksheet(sheetName)
    const dataEntry = data.find(e => e.sheet === sheetName)
    if (!dataEntry) continue
    
    const dataSheet = [...dataEntry.data]
    const headerEntry = header.find(e => e.sheet === sheetName)
    if (headerEntry) {
      dataSheet.unshift(headerEntry.data)
    }
    if (multiHeader.length > 0) {
      const multiHeaderEntry = multiHeader.find(e => e.sheet == sheetName)
      if (multiHeaderEntry) {
        rowData = rowData + multiHeaderEntry.data.length
        for (let i = multiHeaderEntry.data.length - 1; i > -1; i--) {
          const col = multiHeaderEntry.data[i]
          dataSheet.unshift(col as string[])
        }
      }
    }
    worksheet.addRows(dataSheet)
    if (merges.length > 0) {
      const mergeEntry = merges.find(e => e.sheet == sheetName)
      if (mergeEntry && mergeEntry.data.length > 0) {
        mergeEntry.data.forEach((item) => {
          worksheet.mergeCells(item.s.r, item.s.c, item.e.r, item.e.c)
        })
      }
    }
    if (autoWidth) {
      worksheet.columns.forEach(column => {
        if (column.values) {
          const lengths = column.values.map(
            v => (v && v.toString().length) || 0
          )
          const maxLength =
            Math.max(...lengths.filter(v => typeof v === 'number')) + 2
          column.width = maxLength
        }
      })
    }
    if (dataValidations.length > 0) {
      const validationEntry = dataValidations.find(e => e.sheet == sheetName)
      if (validationEntry && validationEntry.data.length > 0) {
        const validaciones = validationEntry.data
        worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
          row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
            if (
              rowNumber >= rowData &&
              validaciones.some((e) => e.columnNum == colNumber)
            ) {
              const validacion = validaciones.find(
                (e) => e.columnNum == colNumber
              )!
              cell.dataValidation = {
                type: 'list',
                allowBlank: validacion.allowBlank,
                formulae: validacion.lista
              }
            }
          })
        })
      }
    }
    if (hiddens.length > 0) {
      const hiddenEntry = hiddens.find(e => e.sheet == sheetName)
      if (hiddenEntry) {
        if (hiddenEntry.columns.length > 0) {
          const hideColumns = hiddenEntry.columns
          for (const colNumber of hideColumns) {
            const col = worksheet.getColumn(colNumber)
            col.hidden = true
          }
        }
        if (hiddenEntry.rows && hiddenEntry.rows.length > 0) {
          const hideRows = hiddenEntry.rows
          for (const rowNumber of hideRows) {
            const row = worksheet.getRow(rowNumber)
            row.hidden = true
          }
        }
      }
    }
  }
  return await new Promise(resolve => {
    workbook.xlsx.writeBuffer().then(data => {
      if (download) {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        downloadFile(blob, `${filename}.${bookType}`)
        resolve(true)
      } else {
        resolve(data)
      }
    })
  })
}
